/* eslint-disable import/no-mutable-exports, global-require, no-console */
var braze;
if (process.env.SERVER) {
  /* istanbul ignore */
  braze = {
    initialize: function initialize() {
      return true;
    },
    mock: true
  };
} else {
  try {
    braze = require('appboy-web-sdk');
  } catch (err) {
    console.log('Tried to import appboy-web-sdk, but it\'s not installed \n', err);
    braze = {
      initialize: function initialize() {
        return true;
      },
      mock: true
    };
  }
}
export default braze;